import { root } from './latestVersion';

export const latestVersion = {
  ...root,
};
